import { Link, useParams } from 'react-router-dom'
import { ArrowLeft, ExternalLink, FileText } from 'lucide-react'
import { publications } from '../data/publications'

const PublicationDetail = () => {
  const { slug } = useParams()

  const publication = publications.find((item) => item.slug === slug)

  if (!publication) {
    return (
      <main className="section-shell py-24">
        <p className="text-academic-muted">Publication not found.</p>

        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-academic-blue"
        >
          <ArrowLeft size={16} />
          Back to portfolio
        </Link>
      </main>
    )
  }

  return (
    <main className="min-h-screen bg-academic-bg">
      <section className="section-shell py-20 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-academic-blue transition hover:opacity-70"
        >
          <ArrowLeft size={16} />
          Back to portfolio
        </Link>

        <div className="mt-10 max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-academic-line bg-white px-4 py-2 text-sm text-academic-muted">
            <FileText size={16} />
            {publication.type} · {publication.status}
          </div>

          <h1 className="mt-8 text-4xl font-semibold tracking-tight text-academic-text md:text-5xl">
            {publication.title}
          </h1>

          <p className="mt-6 text-lg leading-8 text-academic-muted">
            {publication.abstract}
          </p>

          {publication.link && (
            <a
              href={publication.link}
              target="_blank"
              rel="noreferrer"
              className="mt-8 inline-flex items-center gap-2 rounded-2xl bg-academic-blue px-5 py-3 text-sm font-semibold text-white transition hover:opacity-90"
            >
              {publication.linkLabel || 'Open related link'}
              <ExternalLink size={16} />
            </a>
          )}
        </div>

        {publication.image && (
          <div className="mt-12 overflow-hidden rounded-[2rem] border border-academic-line bg-white shadow-sm">
            <img
              src={publication.image}
              alt={publication.title}
              className="h-[320px] w-full object-cover md:h-[460px]"
            />
          </div>
        )}

        <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_280px]">
          <article className="card p-7 md:p-10">
            <h2 className="text-2xl font-semibold text-academic-text">
              Overview
            </h2>

            <div className="mt-6 space-y-6">
              {publication.content.map((paragraph, index) => (
                <p
                  key={index}
                  className="text-base leading-8 text-academic-muted"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </article>

          <aside className="card h-fit p-6">
            <h3 className="font-semibold text-academic-text">
              Topics
            </h3>

            <div className="mt-5 flex flex-wrap gap-2">
              {publication.topics.map((topic) => (
                <span
                  key={topic}
                  className="rounded-full border border-academic-line bg-white px-3 py-1 text-xs font-medium text-academic-muted"
                >
                  {topic}
                </span>
              ))}
            </div>

            {publication.link && (
              <a
                href={publication.link}
                target="_blank"
                rel="noreferrer"
                className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-academic-line bg-white px-4 py-3 text-sm font-semibold text-academic-text transition hover:border-academic-blue hover:text-academic-blue"
              >
                {publication.linkLabel || 'Related link'}
                <ExternalLink size={15} />
              </a>
            )}
          </aside>
        </div>
      </section>
    </main>
  )
}

export default PublicationDetail